/**
 * Builds a regex for matching a region name inside a pack name.
 * - Escapes regex chars
 * - Treats whitespace as optional, so "Region A" matches "RegionA"
 */
export const createRegionRegex = (region) => {
  if (!region) return /(?!)/; // never match if region is empty
  const escaped = String(region).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const pattern = escaped.replace(/\s+/g, "\\s*");
  return new RegExp(`\\b${pattern}\\b`, "i");
};

